import { z } from "zod";
import { ZProjectBase, ZDrofusSettings, ZProjectMember, ZProjectInvite, } from "../projectBase.schema";
export const PROJECTS_COLLECTION_NAME = "projects";
export const ZProjectMongoDocument = ZProjectBase.extend({
    drofus: ZDrofusSettings.optional(),
    members: z.array(ZProjectMember).default([]),
    invites: z.array(ZProjectInvite).default([]),
});
